import { ProgramConfig } from '../../types/apiModels'

export const hasAreaSubtraction = (
  programConfig: ProgramConfig | null | undefined,
  type: string,
): boolean => programConfig?.effectiveAreaSubtractions?.some(rule => rule.type === type) === true

export const isEligibilityEnabled = (programConfig: ProgramConfig | null | undefined): boolean =>
  hasAreaSubtraction(programConfig, 'eligibility')

export const isProjectAreaEnabled = (programConfig: ProgramConfig | null | undefined): boolean =>
  hasAreaSubtraction(programConfig, 'projectArea')
